import React from "react";
import PropTypes from "prop-types";
import StandardField from "./StandardField";
import PhoneField from "./PhoneField";
import StateField from "./StateField";
import SelectField from "./SelectField";
import TextAreaField from "./TextAreaField"; // Import the new component

const RenderFields = ({
  fields,
  formData,
  handleChange,
  readOnly = false,
  fieldTransformers = {},
  validationErrors = {},
}) => {
  const gridTemplateColumns = "repeat(auto-fit, minmax(410px, 1fr))";

  return (
    <div
      className="grid gap-x-10 gap-y-2 w-full"
      style={{ gridTemplateColumns }}
    >
      {fields.map((field) => {
        // Per-field override.
        const fieldReadOnly = field.forceReadOnly ? true : readOnly;

        if (field.key === "state") {
          return (
            <StateField
              key={field.key}
              field={field}
              formData={formData}
              handleChange={handleChange}
              readOnly={fieldReadOnly}
              validationErrors={validationErrors}
            />
          );
        }
        if (field.type === "phone") {
          return (
            <PhoneField
              key={field.key}
              field={field}
              formData={formData}
              handleChange={handleChange}
              readOnly={fieldReadOnly}
              validationErrors={validationErrors}
            />
          );
        }
        if (field.type === "select" && field.options) {
          return (
            <SelectField
              key={field.key}
              field={field}
              formData={formData}
              handleChange={handleChange}
              readOnly={fieldReadOnly}
              validationErrors={validationErrors}
            />
          );
        }
        if (field.type === "textArea") {
          return (
            <TextAreaField
              key={field.key}
              field={field}
              formData={formData}
              handleChange={handleChange}
              readOnly={fieldReadOnly}
              validationErrors={validationErrors}
              fieldTransformer={fieldTransformers[field.key]}
            />
          );
        }
        return (
          <StandardField
            key={field.key}
            field={field}
            formData={formData}
            handleChange={handleChange}
            readOnly={fieldReadOnly}
            validationErrors={validationErrors}
            fieldTransformer={fieldTransformers[field.key]}
          />
        );
      })}
    </div>
  );
};

RenderFields.propTypes = {
  fields: PropTypes.array.isRequired,
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  fieldTransformers: PropTypes.object,
  validationErrors: PropTypes.object,
};

export default RenderFields;
